exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".orgdiagram{outline-width:0;overflow:scroll;transform:translateZ(0)}.employeeTemplateTitleBackground{background-color:rgba(25,118,210,.8);-moz-border-radius:2px;-webkit-border-radius:2px;-khtml-border-radius:2px;border-radius:5px 5px 5px 0;width:100%;height:20px;overflow:hidden;transform:translateZ(0)}.employeeTemplateTitle{text-overflow:ellipsis;-o-text-overflow:ellipsis;overflow:hidden;word-wrap:break-word}.imageContainer{width:56px;height:70px;top:30px;left:5px}.bp-highlight-frame{box-shadow:0 3px 10px rgba(0,0,0,.4)}.employeeInfo{width:113px;font-size:12px;left:82px;padding-top:3px;text-overflow:ellipsis;-o-text-overflow:ellipsis;overflow:hidden}.employeeIcon{left:65px;width:16px;height:16px;font-size:16px!important;color:rgba(0,0,0,.5411)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/orgChartCustomStyles.css
// module id = 1302
// module chunks = 0